// Capture marketing attribution (UTM params + referrer + ?source=) once per session.
// UTM params usually only exist on the first landing URL, so we persist them.
const KEY = "bh_attribution";

export function captureAttribution() {
  if (sessionStorage.getItem(KEY)) return; // already captured this session
  const p = new URLSearchParams(window.location.search);
  const data = {
    source: p.get("source") || "",
    utm_source: p.get("utm_source") || "",
    utm_medium: p.get("utm_medium") || "",
    utm_campaign: p.get("utm_campaign") || "",
    referrer: document.referrer || "",
    landing_page: window.location.pathname + window.location.search,
  };
  sessionStorage.setItem(KEY, JSON.stringify(data));
}

export function getAttribution() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
}
